const EMAIL_DOMAIN_PATTERN = /@.*$/;
const NAME_SEPARATORS_PATTERN = /[._\-\s]+/;

/**
 * Initials shown in the header avatar.
 *
 * @param name - The user's name, or the e-mail when the name is not known yet.
 * @returns The first letter of the first and of the last word, upper case;
 * one letter for a single word; an empty string when nothing is left.
 *
 * @remarks
 * Same rule as the company design system: the e-mail domain is dropped and
 * `.`, `_` and `-` count as spaces, so `ricardo.bonin@tecomec.com.br` gives
 * "RB" instead of "R".
 */
export function getUserInitials(name: string | null | undefined): string {
  if (typeof name !== 'string') {
    return '';
  }
  const words = name
    .replace(EMAIL_DOMAIN_PATTERN, '')
    .split(NAME_SEPARATORS_PATTERN)
    .filter((word) => word.length > 0);
  if (words.length === 0) {
    return '';
  }
  const first = Array.from(words[0])[0];
  if (words.length === 1) {
    return first.toLocaleUpperCase();
  }
  const last = Array.from(words[words.length - 1])[0];
  return `${first}${last}`.toLocaleUpperCase();
}
